import { render, staticRenderFns } from "./FilterReportsModal.vue?vue&type=template&id=672c68e4&scoped=true&lang=pug"
import script from "./FilterReportsModal.vue?vue&type=script&lang=js"
export * from "./FilterReportsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c68e4",
  null
  
)

export default component.exports